/**
 * Parse a YouTube video id out of a pasted URL (watch/embed/youtu.be/vi) or return the
 * raw id when the input has no recognizable delimiter. Shared by the core and presentation
 * EmbedMedia components (#21305). Always returns a string — the previous core copy could
 * return the raw split array for delimiter-less input.
 */
export function getYouTubeId(initialUrl: string): string {
  let id: string | string[] = ''
  const url = initialUrl.replace(/(>|<)/g, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/)
  if (url[2] !== undefined) {
    id = url[2].split(/[^\w-]/)
    id = id[0]
  } else {
    id = url
  }
  return Array.isArray(id) ? id[0] : id
}
